"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractValidationPlugin_1 = __importDefault(require("./AbstractValidationPlugin"));
var isEmail_1 = __importDefault(require("validator/lib/isEmail"));
console.debug('INFO EmailValidationPlugin.ts loaded');
var EmailValidationPlugin = /** @class */ (function (_super) {
    __extends(EmailValidationPlugin, _super);
    function EmailValidationPlugin(field) {
        var _this = _super.call(this, field) || this;
        _this.field = field;
        _this.errorAttribute = 'data-email-error-message';
        return _this;
    }
    EmailValidationPlugin.prototype.runCustomValidation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var email, isEmailValid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        email = this.field.value;
                        this.errorAttribute = 'data-email-error-message';
                        if (!email) {
                            this.field.setCustomValidity('');
                            return [2 /*return*/];
                        }
                        isEmailValid = (0, isEmail_1.default)(email, { allow_utf8_local_part: false, domain_specific_validation: true });
                        if (!(isEmailValid && !this.field.hasAttribute('data-notlscheck'))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.checkForTls(email)];
                    case 1:
                        isEmailValid = _a.sent();
                        if (!isEmailValid) {
                            this.errorAttribute = 'data-email-error-tls-message';
                        }
                        _a.label = 2;
                    case 2:
                        this.field.setCustomValidity(isEmailValid ? '' : 'Your input does not match the requirements.');
                        return [2 /*return*/];
                }
            });
        });
    };
    EmailValidationPlugin.prototype.isValid = function () {
        return this.field.validity.valid;
    };
    EmailValidationPlugin.prototype._getMessageAttribute = function () {
        return this.errorAttribute;
    };
    EmailValidationPlugin.prototype._getDefaultMessage = function () {
        return 'Your input does not match the requirements.';
    };
    EmailValidationPlugin.prototype.checkForTls = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            var actionUrl, tlsCheckUrl, response, parsedResponse, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.addSpinner();
                        actionUrl = this.field.form.getAttribute('action');
                        tlsCheckUrl = actionUrl.replace('.send.json', '.checkTls.json') + '?email=' + encodeURIComponent(email);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, fetch(tlsCheckUrl, { method: 'GET', credentials: 'same-origin' })];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, response.json()];
                    case 3:
                        parsedResponse = _a.sent();
                        if (!this.isTlsCheckResponse(parsedResponse)) {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, parsedResponse.valid === true];
                    case 4:
                        error_1 = _a.sent();
                        console.error('TLS email validation request failed:', error_1);
                        return [2 /*return*/, false];
                    case 5:
                        this.removeSpinner();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    EmailValidationPlugin.prototype.isTlsCheckResponse = function (response) {
        if (typeof response !== 'object' || response === null) {
            return false;
        }
        var valid = response.valid;
        return typeof valid === 'boolean';
    };
    EmailValidationPlugin.prototype.addSpinner = function () {
        if (!this.field.parentElement.querySelector('.c-input__addon')) {
            this.field.parentElement.insertAdjacentHTML('beforeend', this.getSpinnerHtml());
        }
    };
    EmailValidationPlugin.prototype.removeSpinner = function () {
        var _a;
        (_a = this.field.parentElement.querySelector('.c-input__addon')) === null || _a === void 0 ? void 0 : _a.remove();
    };
    EmailValidationPlugin.prototype.getSpinnerHtml = function () {
        return ("<span class=\"c-input__addon\">" +
            "    <div class=\"c-spinner  c-spinner--small\" aria-live=\"polite\" aria-busy=\"true\">" +
            "        <div class=\"c-spinner__loader\">" +
            "            <div class=\"c-upload-item__interaction-icons\">" +
            "                <span class=\"c-spinner__element\"></span>" +
            "            </div>" +
            "        </div>" +
            "     </div>" +
            "</span>");
    };
    return EmailValidationPlugin;
}(AbstractValidationPlugin_1.default));
exports.default = EmailValidationPlugin;
